import { Model } from "@interfaces/model.interface";

export interface CriticalSpare extends Model {
	cost: number;
	leadTimeDays: number;
	machineId?: number;
	maximumStock: number;
	minimumStock: number;
	productionToolId?: number;
	purchasableItemId: number;
	supplierId: number;
}

export class CriticalSpare implements CriticalSpare {	
	constructor(data?: Partial<CriticalSpare>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}